var ua = navigator.userAgent || '';
export var isWechatWebview = ua.toLowerCase().indexOf('micromessenger') > -1;
export var isMiniprogram = (isWechatWebview && ua.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram';
